export const EMAIL_CAMPAIGNS_RESET_STATE = 'EMAIL_CAMPAIGNS_RESET_STATE';
export const EMAIL_CAMPAIGNS_CURRENT_ITEM = 'EMAIL_CAMPAIGNS_CURRENT_ITEM';

export const EMAIL_CAMPAIGNS_REQUEST_LOADING = 'EMAIL_CAMPAIGNS_REQUEST_LOADING';
export const EMAIL_CAMPAIGNS_REQUEST_SUCCESS = 'EMAIL_CAMPAIGNS_REQUEST_SUCCESS';
export const EMAIL_CAMPAIGNS_REQUEST_FAILED = 'EMAIL_CAMPAIGNS_REQUEST_FAILED';

export const EMAIL_CAMPAIGNS_CURRENT_ACTION = 'EMAIL_CAMPAIGNS_CURRENT_ACTION';
export const EMAIL_CAMPAIGNS_RESET_ACTION = 'EMAIL_CAMPAIGNS_RESET_ACTION';
